import { useDracoGLTF } from "../../../utils/useDracoGLTF";
import { useMemo } from "react";
import { findObjectStartsWithKey } from "../../../utils/FindObjects";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Hotspot from "../../ui/Hotspot";

import fragmentShaderReplacement from "../shader/VertexColorHeat_replacement.glsl";
import fragmentShaderAddition from "../shader/VertexColorHeat_addition.glsl";
import { Vector3 } from "three";
import { useLayoutEffect } from "react";

import HowitworksProcess1 from "./howitworks/HowitworksProcess1";
import HowitworksProcess2 from "./howitworks/HowitworksProcess2";

import fragmentShaderReplacement2 from "../shader/VertexColorHeat_Distance_replacement_frag.glsl";
import fragmentShaderAddition2 from "../shader/VertexColorHeat_Distance_addition_frag.glsl";

import vertexShaderReplacement2 from "../shader/VertexColorHeat_Distance_replacement_vert.glsl";
import vertexShaderAddition2 from "../shader/VertexColorHeat_Distance_addition_vert.glsl";

import { useSpring } from "@react-spring/three";
import { useState } from "react";
import { useRef } from "react";
import { Ebbne, MountWithEbbne, useEbbne } from "@solidwhite/ebbnen";
import SetCameraTarget from "../SetCameraTarget";
import { SideBarHider } from "../../ui/SideBar/SideBar";

const HowItWorks = ({ ...props }) => {
  const { t } = useTranslation();
  const { nodes, scene, animations } = useDracoGLTF("./models/heat/howitworks.glb");

  const [glowing, setglowing] = useState(false);

  const materialRef = useRef();

  const hotSpots = useMemo(() => {
    var hotspots = [];
    var hsParent;
    // if (currentLevel == 2) {
    hsParent = findObjectStartsWithKey("Labels_Root", scene);
    // }
    if (hsParent) {
      hsParent.children.forEach((c) => hotspots.push(c));
    }

    return hotspots;
  }, []);

  const cameraTargets = useMemo(() => {
    var obj = findObjectStartsWithKey("CameraTargets_All", scene);
    var camTargets = {};
    obj.children.forEach((c) => {
      if (c.userData.route) camTargets[c.userData.route] = c;
    });

    return camTargets;
  });

  const coil2 = useMemo(() => {
    return findObjectStartsWithKey("CoilRoot_2", scene);
  }, []);

  const [fullWorkPiece, halfWorkPiece] = useMemo(() => {
    return [
      findObjectStartsWithKey("ME_HowItWorks_full_Workpiece", scene),
      findObjectStartsWithKey("ME_HowItWorks_Workpiece_1", scene),
    ];
  }, []);

  const handleProcess1Mount = (mounted = false) => {
    if (mounted) {
      coil2.visible = false;
      halfWorkPiece.visible = true;
      fullWorkPiece.visible = false;
    } else {
      coil2.visible = true;
      halfWorkPiece.visible = false;
      fullWorkPiece.visible = true;
    }
  };

  useLayoutEffect(() => {
    var workpiece1 = findObjectStartsWithKey("ME_HowItWorks_Workpiece_1", scene);
    // var workpiece2 = findObjectStartsWithKey(
    //   "ME_HowItWorks_Workpiece_2",
    //   scene
    // );
    // workpiece2.visible = false;
    var materialClone = workpiece1.material.clone();
    // var materialClone = new MeshBasicMaterial();

    materialClone.onBeforeCompile = (s) => {
      s.uniforms.uHeat = {
        value: 2.0,
      };
      s.uniforms.uHeatFallof = {
        value: 0.9,
      };
      s.uniforms.uHardened = {
        value: 0.0,
      };
      s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
      s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
      s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement);

      materialClone.userData.shader = s;
    };

    workpiece1.material = materialClone;
    workpiece1.visible = false;
    // workpiece2.material = materialClone;
  }, [scene]);

  useLayoutEffect(() => {
    var workpiece = findObjectStartsWithKey("ME_HowItWorks_full_Workpiece", scene);
    var materialClone = workpiece.material.clone();
    // var materialClone = new MeshStandardMaterial();

    var heatSource = findObjectStartsWithKey("HeatTarget", scene);

    var heatSourceWorld = new Vector3();
    heatSource.getWorldPosition(heatSourceWorld);

    materialClone.uniforms = {
      uHeat: {
        value: 0.0,
      },
      uHeatFallof: {
        value: 0.9,
      },
      ...materialClone.uniforms,
    };

    materialClone.onBeforeCompile = (s) => {
      s.uniforms.uHeat = {
        value: 0.0,
      };
      s.uniforms.uHeatFallof = {
        value: 0.1,
      };
      s.uniforms.uHardened = {
        value: 1.0,
      };
      s.uniforms.uHeatSource = {
        value: heatSourceWorld,
      };
      s.uniforms.uHeatDistance = {
        value: 0.5,
      };
      s.vertexShader = `${vertexShaderAddition2}${s.vertexShader}`;
      s.vertexShader = s.vertexShader.replace(`#include <fog_vertex>`, vertexShaderReplacement2);

      s.fragmentShader = `${fragmentShaderAddition2}\n${s.fragmentShader}`;
      s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
      s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement2);

      materialClone.userData.shader = s;
    };

    materialRef.current = materialClone;
    workpiece.material = materialClone;
  }, [scene]);

  useSpring({
    from: { glow: 0 },
    to: { glow: glowing ? 1 : 0 },
    config: { duration: glowing ? 3500 : 1000 },
    delay: glowing ? 500 : 1,
    onChange: ({ value }) => {
      if (materialRef.current) {
        materialRef.current.userData.shader.uniforms.uHeat.value = value.glow * 5;
      }
    },
  });

  return (
    <group>
      <primitive object={scene} />

      <group
        position={nodes.howitworks_root.position}
        rotation={nodes.howitworks_root.rotation}
        scale={nodes.howitworks_root.scale}
      >
        <Ebbne id="hitprocess1">
          <ProcessLabel hotspot={hotSpots[0]} isAnimation />
          <MountWithEbbne>
            <SideBarHider />
            <SetCameraTarget settingsObject={cameraTargets["/applications/howitworks/process1"]} />
            <MountCallback callback={handleProcess1Mount} />
            <HowitworksProcess1 scene={scene} root={nodes.howitworks_root} />
          </MountWithEbbne>
        </Ebbne>
      </group>

      <Ebbne id="hitprocess2">
        <group
          position={nodes.howitworks_root.position}
          rotation={nodes.howitworks_root.rotation}
          scale={nodes.howitworks_root.scale}
        >
          <ProcessLabel hotspot={hotSpots[1]} isAnimation />
        </group>

        <MountWithEbbne>
          <SideBarHider />
          <SetCameraTarget settingsObject={cameraTargets["/applications/howitworks/process2"]} />
          <MountCallback callback={setglowing} />
          <HowitworksProcess2 scene={scene} />
        </MountWithEbbne>
      </Ebbne>
    </group>
  );
};

const ProcessLabel = ({ hotspot, delay = 0, isAnimation = false, ...props }) => {
  const { selectable, select } = useEbbne();

  const { t } = useTranslation();

  const handleLabelClick = (e) => {
    e.stopPropagation();
    select();
  };

  return (
    selectable && (
      <Hotspot
        position={hotspot.position}
        text={hotspot.userData.textId ? t(hotspot.userData.textId) : hotspot.name.toUpperCase()}
        topLeft
        onClick={(e) => handleLabelClick(e)}
        delay={20 + 300 * delay}
        id={hotspot.name}
        isAnimation={isAnimation}
      />
    )
  );
};

const MountCallback = ({ callback = (bool = false) => {}, ...props }) => {
  useEffect(() => {
    callback(true);
    return () => {
      callback(false);
    };
  }, []);
  return null;
};

export default HowItWorks;
